import React, { Suspense } from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import Header from "../../components/Header/Header";
import { OverlayLoading } from "../../components/OverlayLoading/OverlayLoading";
import { Unauthorized } from "../../components/PrivateRoute";
import { isAdminOrSuperAdmin } from "../../utils";
import { useAuthentication } from "../../reducer/authentication";
import UserAdminType from "../../enum/UserAdminType";
import { hasAnyAdminPermission, hasAnyReportPermission } from "../System/Administration/Users/UserPermissions";

const Administration = React.lazy(() => import('./Administration'));
const TechnicalAssistance = React.lazy(() => import('./TechnicalAssistance'));
const Task = React.lazy(() => import('./Task'));
const Reports = React.lazy(() => import('./Reports'));
const TechAssisTracking = React.lazy(() => import('./TechAssisTracking'));
const Production = React.lazy(() => import('./Production'));
const Activities = React.lazy(() => import('./Activities'));
const OrdersReceived = React.lazy(() => import('./OrdersReceived'));
// const SupportTickets = React.lazy(() => import('./Support'));
const ProdEng = React.lazy(() => import('./ProdEng'));
const Ocurrences = React.lazy(() => import('./Ocurrences'));
const GameClickCircle = React.lazy(() => import('../../components/Games/ClickCircle'));
const ClientsDashboard = React.lazy(() => import('./ClientsDashboard/ClientsDashboard'));
const Documentation = React.lazy(() => import('./Documentation'));
const DocumentationPage = React.lazy(() => import('./Documentation/DocumentationPage'));
const Lanzacoins = React.lazy(() => import('./Lanzacoins'));
const ProjectsDashboard = React.lazy(() => import('./ProjectsDashboard'));
const LicensesDashboard = React.lazy(() => import('./LicensesDashboard'));

export default function SystemRoot() {
    const match = useRouteMatch();
    const { user } = useAuthentication();
    const isAdmin = isAdminOrSuperAdmin(user);
    
    return (
        <>
            <Header />
            <Suspense fallback={<OverlayLoading loading />}>
                <Switch>
                    <Route path={match.path} exact>
                        <p>System</p>
                    </Route>                    
                    {hasAnyAdminPermission(user?.permissions) ? <Route path={match.path + '/administration'} component={Administration} /> : null}
                    {user?.perm_tech_assis ? <Route path={match.path + '/technicalAssistance'} component={TechnicalAssistance} /> : null}
                    {user?.perm_task ? <Route path={match.path + '/task'} component={Task} /> : null}
                    {user?.tech_assis_tracking_perm ? <Route path={match.path + '/techAssisTracking'} component={TechAssisTracking} /> : null}
                    {user?.perm_production ? <Route path={match.path + '/production'} component={Production} /> : null}
                    {hasAnyReportPermission(user?.permissions) ? <Route path={match.path + '/reports'} component={Reports} /> : null}
                    {user?.perm_task ? <Route path={match.path + '/activities'} component={Activities} /> : null}
                    {user?.perm_task ? <Route path={match.path + '/lanzacoins'} component={Lanzacoins} /> : null}
                    {user?.perm_order_received ? <Route path={match.path + '/ordersReceived'} component={OrdersReceived} /> : null}
                    <Route path={match.path + '/clients'} component={ClientsDashboard} />
                    {/* <Route path={match.path + '/support'} component={SupportTickets} /> */}
                    <Route path={match.path + '/prodEng'} component={ProdEng} />
                    <Route path={match.path + '/ocurrence'} component={Ocurrences} />
                    <Route path={match.path + '/documentation2'} component={Documentation} />
                    <Route path={match.path + '/documentation'} component={DocumentationPage} />
                    <Route path={match.path + '/game/clickCircle'} component={GameClickCircle} />
                    {user?.admin_type === UserAdminType.SuperAdmin ? <Route path={match.path + '/projectsDashboard'} component={ProjectsDashboard} /> : null}
                    <Route path={match.path + '/licensesDashboard'} component={LicensesDashboard} />
                    <Route>
                        <Unauthorized redirectUrl={false} />
                    </Route>
                </Switch>
            </Suspense>
        </>
    )
}
